import React from 'react'
import InlineSVG from 'components/InlineSVG'

const Form = (props) => {
  const onSubmit = (e) => {
    e.preventDefault()
    props.onSubmit(props.searchString)
  }

  return (
    <form onSubmit={onSubmit}>
      <div className='input-wrapper'>
        <input
          placeholder={props.placeholder || 'Enter your search term here...'}
          type='searchString'
          name='searchString'
          value={props.searchString}
          autoComplete='off'
          onChange={props.onInputChange}
        />
        <button type='submit'>
          <InlineSVG icon='search' />
          <span>Search</span>
        </button>
      </div>
    </form>
  )
}

export default Form



// WEBPACK FOOTER //
// ./src/components/Header/Search/Form/index.js